export default __webpack_public_path__ + "static/media/chain-modal-share.41273b5f.svg";